import React from 'react';
import { Video } from 'elements';

const Background = ({ video, cl }) => {
  return <div className={cl('bg-wrapper')}>{video && <Video src={[video]} autoPlay={true} loop={true} />}</div>;
};

export default Background;
